import { FC, useEffect, useState } from "react";
import { Form, Row, Col } from "antd";
import moment from "moment";
import {
  FormItem,
  FormItemWrapper,
  FormItemWrapperLeft,
} from "./elements";
import { InputWithLabel } from "../../molecules/InputWithLabel";
import { SelectWithLabel } from "../../molecules/SelectWithLabel";
import { DatePickerWithLabel } from "../../molecules/DatePickerWithLabel";
import { Alert } from "../../atoms/Alert";
import { Props } from "./types";
import { validation } from "../../../constants";

const PersonalProfileForm: FC<Props> = (props) => {
  const [isValidFullNameLength, setIsValidFullNameLength] = useState(true);
  const {
    onFinish,
    validateMessages,
    positionAppliedOptionItems,
    civilStatusOptionItems,
    degreeOptionItems,
    formRef,
    gutter,
    textRules,
    commonRules,
    applicantInfo,
  } = props;

  const onFieldsChange = (_: any[], allFields: any[]) => {
    const [firsName, middleName, lastName] = allFields;
    const validFullNameLength =
      (firsName.value || "").length +
        (middleName.value || "").length +
        (lastName.value || "").length <=
      50;
    setIsValidFullNameLength(validFullNameLength);
  };

  const salaryRestriction: object = validation.salaryRangeRestriction;

  useEffect(() => {
    if (!isValidFullNameLength) {
      setTimeout(() => {
        setIsValidFullNameLength(true);
      }, 3000);
    }
  }, [isValidFullNameLength]);

  const [formValues, setFormValues] = useState<any>({});
  const updateFieldValues = (e: any, field: string) => {
    const directValues = [
      "birthdate",
      "date_completed",
      "expected_salary",
      "position_applied",
      "civil_status",
      "degree",
    ];

    setFormValues({
      ...formValues,
      [field]: directValues.includes(field)
        ? e
        : field === "expected_salary"
        ? parseInt(e)
        : e.target.value,
    });
    formRef.setFieldsValue({
      [field]: directValues.includes(field)
        ? e
        : field === "expected_salary"
        ? parseInt(e)
        : e.target.value,
    });
  };
  useEffect(() => {
    const fieldValues = formRef.getFieldsValue();
    const expected_salary = fieldValues?.expected_salary && parseInt(String(fieldValues?.expected_salary).replace(/,/g, '')).toLocaleString();
    const prevFieldValues = {
      ...fieldValues,
      expected_salary,
    };
    setFormValues(prevFieldValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Form
        onFinish={onFinish}
        validateMessages={validateMessages}
        form={formRef}
        style={{ marginBottom: "30px" }}
        onFieldsChange={onFieldsChange}
      >
        {/* <ImageWrapper>
          <Image src={image || defaultAvatar} alt="avatar" />
        </ImageWrapper>
        <UploadWrapper>
          <Label onClick={openImageUpload}>Upload</Label>
        </UploadWrapper>
        <InputFile
          type="file"
          className="form-control"
          onChange={uploadSingleFile}
          ref={inputFile}
        /> */}
        <Row gutter={gutter}>
          <Col span={24}>
            <FormItem name="first_name" label="First Name" rules={[textRules]}>
              <span id={"first_name"}>
                <InputWithLabel
                  label="First Name"
                  type="default"
                  value={formValues?.first_name}
                  onChange={(e) => {
                    updateFieldValues(e, "first_name");
                  }}
                />
              </span>
            </FormItem>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12}>
            <FormItem
              name="middle_name"
              label="Middle Name"
              rules={[validation.whitespace]}
            >
              <span id={"middle_name"}>
                <InputWithLabel
                  label="Middle Name"
                  type="default"
                  value={formValues?.middle_name}
                  onChange={(e) => {
                    updateFieldValues(e, "middle_name");
                  }}
                />
              </span>
            </FormItem>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12}>
            <FormItem name="last_name" label="Last Name" rules={[textRules]}>
              <span id={"last_name"}>
                <InputWithLabel
                  label="Last Name"
                  type="default"
                  value={formValues?.last_name}
                  onChange={(e) => {
                    updateFieldValues(e, "last_name");
                  }}
                />
              </span>
            </FormItem>
          </Col>
        </Row>
        <Row gutter={gutter}>
          <FormItemWrapperLeft>
            <FormItem
              name="position_applied"
              label="Position applied"
              rules={[textRules]}
            >
              <span id={"position_applied"}>
                <SelectWithLabel
                  label="Position Applied"
                  selectOnChange={(e: any) => {
                    const selected = JSON.parse(e);
                    props?.onSelectPosition && props.onSelectPosition({ 
                      position: selected.position, 
                      skills: selected.skills, 
                      key: selected.key 
                    });
                    updateFieldValues(selected.position, "position_applied");
                  }
                    
                  }
                  optionItems={positionAppliedOptionItems}
                  selectDefaultValue={
                    applicantInfo?.positionApplied || undefined
                  }
                  getPopupContainer={(trigger: any) => trigger.parentNode}
                />
              </span>
            </FormItem>
          </FormItemWrapperLeft>
          <FormItemWrapper>
            <FormItem
              name="expected_salary"
              label="Expected salary"
              rules={[commonRules, { ...salaryRestriction }]}
            >
              <span id={"expected_salary"}>
                <InputWithLabel
                  label="Expected Salary (PHP)"
                  type="currency"
                  value={formValues?.expected_salary}
                  onChange={(e) => {
                    updateFieldValues(e, "expected_salary");
                  }}
                />
              </span>
            </FormItem>
          </FormItemWrapper>
        </Row>
        <Row gutter={gutter}>
          <FormItemWrapperLeft>
            <FormItem
              name="birthdate"
              label="Birthdate"
              rules={[
                commonRules,
                () => ({
                  validator(_, value) {
                    let age = moment().diff(value, "years");

                    if (age >= 18) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject(
                        new Error("Must be 18 years old or above")
                      );
                    }
                  },
                }),
              ]}
              style={{ height: "100%" }}
            >
              <span id={"birthdate"}>
                <DatePickerWithLabel
                  label="Date of Birth"
                  getPopupContainer={(trigger: any) => trigger.parentNode}
                  value={formValues?.birthdate}
                  onChange={(e) => {
                    updateFieldValues(e, "birthdate");
                  }}
                />
              </span>
            </FormItem>
          </FormItemWrapperLeft>
          <FormItemWrapper>
            <FormItem name="civil_status" label="Status" rules={[commonRules]}>
              <span id={"civil_status"}>
                <SelectWithLabel
                  label="Civil Status"
                  selectOnChange={(e) => updateFieldValues(e, "civil_status")}
                  optionItems={civilStatusOptionItems}
                  selectDefaultValue={applicantInfo?.civilStatus || undefined}
                  getPopupContainer={(trigger: any) => trigger.parentNode}
                />
              </span>
            </FormItem>
          </FormItemWrapper>
        </Row>
        <Row gutter={gutter}>
          <FormItemWrapperLeft>
            <FormItem name="degree" label="Degree" rules={[commonRules]}>
              <span id={"degree"}>
                <SelectWithLabel
                  label="Educational Attainment"
                  selectOnChange={(e) => updateFieldValues(e, "degree")}
                  optionItems={degreeOptionItems}
                  selectDefaultValue={applicantInfo?.degree || undefined}
                  getPopupContainer={(trigger: any) => trigger.parentNode}
                />
              </span>
            </FormItem>
          </FormItemWrapperLeft>
          <FormItemWrapper>
            <FormItem
              name="date_completed"
              label="Year and Month "
              rules={[commonRules]}
            >
              <span id={"date_completed"}>
                <DatePickerWithLabel
                  label="Year & Month Completed"
                  picker="month"
                  getPopupContainer={(trigger: any) => trigger.parentNode}
                  value={formValues?.date_completed}
                  onChange={(e) => {
                    updateFieldValues(e, "date_completed");
                  }}
                />
              </span>
            </FormItem>
          </FormItemWrapper>
        </Row>
        <Row gutter={gutter}>
          <Col span={24}>
            <FormItem name="school" label="Name of school" rules={[textRules]}>
              <span id={"school"}>
                <InputWithLabel
                  label="Name of School"
                  type="default"
                  value={formValues?.school}
                  onChange={(e) => {
                    updateFieldValues(e, "school");
                  }}
                />
              </span>
            </FormItem>
          </Col>
        </Row>
        <Row gutter={gutter}>
          <Col span={24}>
            <FormItem name="course" label="Course" rules={[textRules]}>
              <span id={"course"}>
                <InputWithLabel
                  label="Course Taken"
                  type="default"
                  value={formValues?.course}
                  onChange={(e) => {
                    updateFieldValues(e, "course");
                  }}
                />
              </span>
            </FormItem>
          </Col>
        </Row>
        <Row gutter={gutter}>
          <Col span={24}>
            <FormItem
              name="portfolio"
              label="Portfolio"
              rules={[{ type: "url" }]}
            >
              <span id={"portfolio"}>
                <InputWithLabel
                  label="Do you have any sample work or portfolio? (Optional)"
                  type="default"
                  value={formValues?.portfolio}
                  onChange={(e) => {
                    updateFieldValues(e, "portfolio");
                  }}
                />
              </span>
            </FormItem>
          </Col>
        </Row>
        <Row gutter={gutter}>
          <Col span={24}>
            <FormItem
              name="referred_by"
              label="Referred By(Optional)"
              rules={[validation.whitespace]}
            >
              <span id={"referred_by"}>
                <InputWithLabel
                  label="Referred By(Optional)"
                  type="default"
                  value={formValues?.referred_by}
                  onChange={(e) => {
                    updateFieldValues(e, "referred_by");
                  }}
                />
              </span>
            </FormItem>
          </Col>
        </Row>
      </Form>
      {!isValidFullNameLength && (
        <Alert
          width={620}
          bottom={35}
          type="error"
          message="Full name cannot exceed to 50 characters."
          showIcon
        />
      )}
    </>
  );
};

export default PersonalProfileForm;
